// src/modules/purityAnalyzer/components/KaratBadge.jsx
// Karat classification chip (24K / 22K / 20K / 18K) with fineness subtitle.

import React from 'react';
import { Tag, Tooltip } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import { KARAT_COLORS } from '../constants/purityConstants';

export default function KaratBadge({ karat, fineness, size = 'default' }) {
  if (!karat) return null;
  const color = KARAT_COLORS[karat] || '#8c8c8c';
  const tag = (
    <Tag
      icon={<CrownOutlined />}
      style={{
        background: `${color}22`,
        color,
        borderColor: `${color}55`,
        fontWeight: 600,
        fontSize: size === 'large' ? 16 : 12,
        padding: size === 'large' ? '4px 14px' : undefined,
        borderRadius: 999,
      }}
    >
      {karat}
    </Tag>
  );
  return fineness ? <Tooltip title={fineness}>{tag}</Tooltip> : tag;
}
